export default [
  {
    path: "list",
    component: resolve => require(["../views/user/list.vue"], resolve)
  },
  {
    path: "list/photo/:id",
    component: resolve => require(["../views/user/photo.vue"], resolve)
  },
  {
    path: "list/profile/:id",
    component: resolve => require(["../views/user/profile.vue"], resolve)
  },
  {
    path: "group",
    component: resolve => require(["../views/user/group.vue"], resolve)
  },
  {
    path: "tag",
    name: "userTag",
    component: resolve => require(["../views/user/tag.vue"], resolve)
  },
  {
    path: "company",
    name: "company",
    component: resolve => require(["../views/user/company.vue"], resolve)
  },
  {
    path: "company/insight/:id",
    name: "companyInsight",
    component: resolve => require(["../views/user/insight.vue"], resolve)
  },
  {
    path: "tagEdit/:tagId",
    name: "userTagEdit",
    component: resolve => require(["../views/user/TagEdit.vue"], resolve)
  },
  {
    path: "approval",
    component: resolve => require(["../views/user/approval.vue"], resolve)
  }
];
